(function (global) {
  'use strict';
  function mount(section) {
    var holder = section.querySelector('[data-cl-inline-payments]');
    if (!holder) return null;
    var wallets = holder.querySelector('[data-cl-payment-wallets]');
    var status = holder.querySelector('[data-cl-payment-status]');
    var revision = 0, added = false;
    function invalidate() {
      revision++;
      added = false;
      holder.hidden = false;
      status.textContent = '';
      wallets.replaceChildren();
    }
    async function show(expectedRevision) {
      if (revision !== expectedRevision) return;
      added = true;
      holder.hidden = false;
      status.textContent = 'Bundle added. Loading Shopify payment options…';
      var url = new URL(section.dataset.clCartUrl, global.location.origin);
      url.searchParams.set('section_id', holder.dataset.clPaymentSection);
      var timer;
      try {
        // Bound this optional read (including its response body). Never retry or
        // time out cart mutations here: Shopify may already have committed them.
        var html = await Promise.race([
          (async function () {
            var response = await global.fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
            if (!response.ok) throw new Error('Payment section could not load');
            return response.text();
          })(),
          new Promise(function (_, reject) {
            timer = global.setTimeout(function () { reject(new Error('Payment options timed out')); }, 8000);
          })
        ]);
        if (revision !== expectedRevision) return;
        var parsed = new global.DOMParser().parseFromString(html, 'text/html');
        var content = parsed.querySelector('[data-cl-native-cart-payments]');
        if (!content) throw new Error('Payment section is missing');
        // Shopify's section-rendered wallet components initialize when inserted.
        // Never invent a Shop link or submit a single-product payment form.
        wallets.replaceChildren.apply(wallets, Array.from(content.childNodes));
        var hasWallets = wallets.querySelector('shopify-accelerated-checkout-cart, [data-shopify-buttoncontainer]');
        status.textContent = hasWallets
          ? 'Bundle added. Payment covers all items currently in your cart.'
          : 'Bundle added. Use Checkout to continue with all cart items.';
      } catch (_) {
        if (revision !== expectedRevision) return;
        wallets.replaceChildren();
        status.textContent = 'Bundle added, but payment options could not load. Use Checkout; do not add the bundle again.';
      } finally {
        global.clearTimeout(timer);
      }
    }
    return { invalidate: invalidate, show: show, revision: function () { return revision; }, isAdded: function () { return added; } };
  }
  global.ClutchLoopInlinePayments = { mount: mount };
})(typeof window !== 'undefined' ? window : globalThis);
